/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  autoWidth: Boolean,
  borderless: Boolean,
  clearable: Boolean,
  collapsedItems: {
    type: Function
  },
  data: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  disabled: Boolean,
  empty: {
    type: [String, Function],
    "default": ""
  },
  filter: {
    type: Function
  },
  filterable: Boolean,
  inputProps: {
    type: Object
  },
  inputValue: {
    type: [String, Number],
    "default": void 0
  },
  defaultInputValue: {
    type: [String, Number]
  },
  keys: {
    type: Object
  },
  loading: Boolean,
  loadingText: {
    type: [String, Function],
    "default": ""
  },
  max: {
    type: Number,
    "default": 0
  },
  minCollapsedNum: {
    type: Number,
    "default": 0
  },
  multiple: Boolean,
  placeholder: {
    type: String,
    "default": void 0
  },
  popupProps: {
    type: Object
  },
  popupVisible: {
    type: Boolean,
    "default": void 0
  },
  prefixIcon: {
    type: Function
  },
  readonly: Boolean,
  selectInputProps: {
    type: Object
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  tagProps: {
    type: Object
  },
  treeProps: {
    type: Object
  },
  value: {
    type: [String, Number, Object, Array],
    "default": void 0
  },
  modelValue: {
    type: [String, Number, Object, Array],
    "default": void 0
  },
  defaultValue: {
    type: [String, Number, Object, Array]
  },
  valueDisplay: {
    type: Function
  },
  valueType: {
    type: String,
    "default": "value",
    validator: function validator(val) {
      if (!val) return true;
      return ["value", "object"].includes(val);
    }
  },
  onBlur: Function,
  onChange: Function,
  onClear: Function,
  onFocus: Function,
  onInputChange: Function,
  onPopupVisibleChange: Function,
  onRemove: Function,
  onSearch: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
